// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-avatar{background:linear-gradient(126.07deg,#ffa34e 28.76%,#ff7245 70.91%)}", ""]);
// Exports
module.exports = exports;
